<template>
  <div>
    <el-card>
      <el-row :gutter="15">

        <el-col>
          <el-date-picker style="float: left;width:300px;margin-bottom: 10px;" value-format="yyyy-MM-dd"
            v-model="dateTimetask" type="daterange" size="small" class="query" range-separator="至"
            start-placeholder="开始日期起始" end-placeholder="开始日期结束" clear-icon @change="() => {
              loadtaskinfo()
            }">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col>
          <div style="height:calc(50vh - 108px)">
            <el-row>
              <el-col>
                <el-table :data="taskinfo.tablelist" ref="singletaskTable" show-overflow-tooltip border stripe size="mini"
                  height="calc(50vh - 108px)" v-loading="loading">
                  <el-table-column type="index" label="序号" width="50" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="工区名称"> </el-table-column>
                  <el-table-column prop="value" label="任务总数">
                  </el-table-column>
                  <el-table-column prop="taskrate" label="任务数占比(%)">
                  </el-table-column>
                  <el-table-column prop="longtimesformat" label="任务时长">
                  </el-table-column>
                  <el-table-column prop="timerate" label="时长占比(%)">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="15">

        <el-col :span="12">
          <div style="height:calc(50vh- 170px);margin-top: 10px;">
            <div id="eletaskpie" style="width:100%;height:350px;margin-top: 10px;">

            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div style="height:calc(50vh- 170px);margin-top: 10px;">
            <div id="eleTasktop" style="width:100%;height:350px;margin-top: 10px;">

            </div>
          </div>
        </el-col>

      </el-row>

    </el-card>

</div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'

export default {
  name: 'taskstatistic',
  data () {
    return {

      queryObj: { starttime: [], endtime: [] },//查询设备条件
      dateTimetask: [],
      taskinfo: {},
      loading: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      let millisecond = 1000 * 60 * 60 * 24;
      this.dateTimetask = [dateutils.dateFormat("YYYY-mm-dd 00:00:00", new Date((new Date()).getTime() - 7 * millisecond)), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.loadtaskinfo()
    },

    loadtaskinfo () {

      //设备表格
      this.loading = true
      this.queryObj.starttime = this.dateTimetask[0]
      this.queryObj.endtime = this.dateTimetask[1]
      this.$ajax.get('/buss/statistictasks/loadtaskinfo', this.queryObj).then(msg => {
        this.taskinfo = msg
        this.inittaskcountPie()
        this.initTopinfoEChart()
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })


    },


    //zhushi

    inittaskcountPie () {
      let myChart = this.$echarts.init(document.getElementById('eletaskpie'))
      var colorList = ['#f1bb4c', '#BEE5FB', '#1EE7E7', '#00D68A', '#1890FF', '#564AF1', '#afa3f5', '#40d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff', '#afa3f5', '#00d488', '#3feed4', '#3bafff', '#f1bb4c', '#aff',];
      var option = {
        title: {
          subtext: '工区任务占总任务百分率',
          x: 'center',
          y: '2%',
          textStyle: {
            fontSize: 18,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#f1bb4c',
            fontSize: 16
          },
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: "middle",
          right: "5%",
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25,
          },
          icon: 'roundRect'
        },
        series: [
          // 主要展示层的
          {
            radius: ['19%', '63%'],
            center: ['50%', '60%'],
            name: '工区名称',
            type: 'pie',
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            labelLine: {
              normal: {
                show: false,
                length: 5,
                length2: 60,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: "#000",
              emphasis: {
                show: false
              }
            },
            label: {
              normal: {
                formatter: function (params) {
                  var str = params.name + params.value;
                  return str
                },
                padding: [0, -90],
                height: 35,
              }
            },
            data: this.taskinfo.otherlist,
          },
          // 边框的设置
          {
            radius: ['58%', '65%'],
            center: ['50%', '60%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1,
            }],
          }
        ]
      };
      myChart.setOption(option)
    },


    initTopinfoEChart () {

      var dateKey = []
      var dateValue = []
      for (var i = 0; i < this.taskinfo.otherlist.length; i++) {
        dateKey.push(this.taskinfo.otherlist[i].name)
        dateValue.push(this.taskinfo.otherlist[i].longtime)
      }

      let myChart = this.$echarts.init(document.getElementById('eleTasktop'))
      var option = {
        title: {
          text: '工区任务时长排名',
          left: 'center',

        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: 'none'
          },

          formatter: params => {
            const {
              name,
              data,
            } = params[0];
            return `
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:12px;">工区${name}</div>
            <div style="font-size: 14px;font-family: Source Han Sans CN-Medium;font-weight: 500;color: #FFFFFF;margin-bottom:4px;">任务时长：${(data / 3600).toFixed()}小时${((data % 3600) / 60).toFixed()}分钟 ${(data % 60).toFixed()}秒</div>`
          },
          extraCssText: 'opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;'
        },
        xAxis: {
          type: 'category',
          data: dateKey,
          axisLabel: {
            showMaxLabel: true,
            interval: 0,
            rotate: 40,
          }
        },
        yAxis: {
          type: 'value',
          name: "单位：毫秒",
        },
        series: [
          {
            data: dateValue,
            barWidth: 20,
            type: 'bar'
          }
        ]
      };
      myChart.setOption(option)
    }

  },

  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottomshadow {
  width: 75%;
  height: 120px;
  margin-left: 25px;
  margin-top: 50px;
  line-height: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: -webkit-gradient(linear,
      0% 0%,
      0% 20%,
      from(#409eff),
      to(#409eff));
  border-radius: 10px;
}
</style>
